import { Component, OnInit, Injectable, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Router } from '@angular/router';
import { WebserviceService } from '../services/webservice.service';
import { DatatransferService } from '../services/datatransfer.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ThrowStmt } from '@angular/compiler';
declare var $;

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  emailvalidation = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+")){2,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  numbervalidation = /^[0-9]+$/;
  alphaWithoutSpace = /^[a-zA-Z]+$/;
  alphanumeric = /^[a-zA-Z0-9]+$/;
  decimalnumber = /^(0|[1-9]\d*)(\.\d+)?$/;
  alphawithdot = /^[a-zA-Z. ]+$/;
  alpha = /^[A-Za-z\s]+$/;
  // passwordvalidation = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/;
  passwordvalidation = /^(?=^.{12,}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s)[0-9a-zA-Z!@#$%^&*()]*$/;  // 1 number, 1 uppercase and 1 special character
  contactnmber = /^[0-9\-+()\d\s]+$/
  p1 = 1;
  p2 = 1;
  p3 = 1;
  p4 = 1;

  addUserForm: any;
  editUserForm: any;
  addTeamForm: any;
  editTeamForm: any;
  addDepartmentForm: any;
  editDepartmentForm: any;
  PrivilagesignupdetailsForm: any;
  showprivilage = 'false';



  /*-core--*/
  private listBUnitsapi = this.getdata.Coreappconstant + 'listBUnits';
  private listModulesapi = this.getdata.Coreappconstant + 'listModules';
  private listDICVPrivilegesapi = this.getdata.Coreappconstant + 'listDICVPrivileges';

  /*--disc--*/
  private dicvSignupapi = this.getdata.appconstant + "dicvSignup";
  private listTeamapi = this.getdata.appconstant + 'listTeam';
  private listDepartmentapi = this.getdata.appconstant + 'listDepartment';
  private listDesignationapi = this.getdata.appconstant + 'listDesignation  ';

  constructor(private Formbuilder: FormBuilder, private router: Router, private makeapi: WebserviceService, private http: Http, private getdata: DatatransferService) {
    this.PrivilagesignupdetailsForm = Formbuilder.group({
      'name': [null, Validators.compose([Validators.required, Validators.minLength(1),Validators.pattern(this.alpha)])],
      'email': [null, Validators.compose([Validators.required, Validators.pattern(this.emailvalidation), Validators.minLength(3)])],
      'shortid': [null, Validators.compose([Validators.required, Validators.minLength(1),Validators.pattern(this.alphanumeric)])],
      'mobilenumber': [null, Validators.compose([Validators.required, Validators.pattern(this.numbervalidation),Validators.minLength(10)])],
      // 'password': ['', Validators.compose([Validators.required, Validators.minLength(12),Validators.pattern(this.passwordvalidation)])],
      // 'cpassword': ['', Validators.compose([Validators.required, Validators.minLength(12),Validators.pattern(this.passwordvalidation)])],
      'bunits': [null, Validators.compose([Validators.required,])],
      'deptname': [null, Validators.compose([Validators.required,])],
      'teamname': [null, Validators.compose([Validators.required,])],
      'deptid': [null],
      'teamid': [null],
      'designationid': [null, Validators.compose([Validators.required,])],
      'phonenumber': [null, Validators.compose([ Validators.pattern(this.numbervalidation),Validators.minLength(6)])],
    });
  }

  ngOnInit() {
    this.resetform();
    this.fetchCaptcha()
  }

  alldepartmentlist: any;

  getalldepartment() {
    let reqdata = ""
    return this.makeapi.method(this.listDepartmentapi, reqdata, "post")
      .subscribe(data => {
        this.alldepartmentlist = data;
      },
        Error => {
        });
  }

  allteamlist: any;
  getallteamforUser(id) {
    this.PrivilagesignupdetailsForm.value.teamid = null;
    let reqdata = "deptid="+ id;
    return this.makeapi.method(this.listTeamapi, reqdata, "post")
      .subscribe(data => {
        this.allteamlist = data;
      },
        Error => {
        });
  }

  getallteam() {
    let reqdata = "deptid="+ 0 ;
    return this.makeapi.method(this.listTeamapi, reqdata, "post")
      .subscribe(data => {
        this.allteamlist = data;
      },
        Error => {
        });
  }
  alldesignation = [];
  getalldesignation() {
    return this.makeapi.method(this.listDesignationapi, "", "postjson")
      .subscribe(data => {
        this.alldesignation = data;
      },
        Error => {
        });
  }
  selectedBUnits = "";
  changec() {
    this.selectedBUnits = '';
    let singleCheckArray = $(".bunitclass:checkbox:checked").map(function () {
      return this.value;
    }).get();

    for (var i = 0; i < singleCheckArray.length; i++) {
      this.selectedBUnits = this.selectedBUnits + singleCheckArray[i] + ','
    }
    this.selectedBUnits = (this.selectedBUnits).slice(0, -1);

    if (singleCheckArray.length == 0) {
      var getform = this.PrivilagesignupdetailsForm.value;
      getform.bunits = null;
      this.PrivilagesignupdetailsForm.patchValue(getform)
    }
  }
  bUnits: any;
  cunits: any;
  formArrayPrivilage = []
  totalprivilageArray = []
  getlistDICVPrivileges() {
    this.totalprivilageArray = [];
    this.formArrayPrivilage = [];

    let reqdata = ""
    return this.makeapi.method(this.listDICVPrivilegesapi, reqdata, "post")
      .subscribe(data => {
        this.formArrayPrivilage = data;
        // if (data.length > 0) {
        // this.formArrayPrivilage = data;
        // for (var i = 0; i < data.length; i++) {
        //   if (data[i].active == 1) {
        //     $('#' + data[i].buid + data[i].compid + data[i].modid + ':checkbox').prop('checked', true);
        //     console.log('#' + data[i].buid + data[i].compid + data[i].modid)
        //   }

        // }
        // }
        // else {
        // let singleCheckArray = $('.privilagesclass:checkbox:checked').map(function () {
        //   var getdata = this.value;
        //   return getdata;
        // }).get();
        // let singleCheckArray2 = $('.privilagesclass:checkbox:not(:checked)').map(function () {
        //   var getdata = this.value;
        //   return getdata;
        // }).get();

        // var activelist = [];
        // var unactivelist = [];

        // for (var i = 0; i < singleCheckArray.length; i++) {
        //   var array = singleCheckArray[i].split("|")
        //   activelist[i] = { "buid": array[0], "compid": array[1], "modid": array[2], "active": 1 }
        // }
        // for (var i = 0; i < singleCheckArray2.length; i++) {
        //   var array = singleCheckArray2[i].split("|")
        //   unactivelist[i] = { "buid": array[0], "compid": array[1], "modid": array[2], "active": 0 }
        // }

        // this.formArrayPrivilage = activelist.concat(unactivelist);
        // }
        for (var z = 0; z < this.formArrayPrivilage.length; z++) {
          this.totalprivilageArray[z] = (this.formArrayPrivilage[z].buid).toString() + (this.formArrayPrivilage[z].compid).toString() + (this.formArrayPrivilage[z].modid).toString();
        }
      },
        Error => {
        });
  }
  switchstatus(buids, components) {
    var active = [];
    var selectedbunits = this.selectedBUnits.split(',');
    if (this.formArrayPrivilageforselected.length > 0 && (selectedbunits.indexOf(buids.toString()) != -1)) {
      for (var i = 0; i < components.length; i++) {
        (buids).toString() + (components[i].id).toString() + (components[i].modid).toString()
        var data = this.formArrayPrivilageforselected.filter(function (el) {
          return (el.buid == (buids).toString() && el.compid == (components[i].id).toString() && el.modid == components[i].modid.toString());
        });
        if (data[0].active == 1)
          active.push(data[0].active)
      }
      if (active.length == 0)
        return "offenable";
      else if (active.length == components.length)
        return "on";
      else
        return "warning"
    }
    else {
      return "off";
    }
  }

  getallcomponents() {
    let reqdata = ""
    return this.makeapi.method(this.listModulesapi, reqdata, "post")
      .subscribe(data => {
        this.cunits = data;
        this.getlistDICVPrivileges();
      },
        Error => {
        });
  }
  getallBUnits() {
    let reqdata = ""
    return this.makeapi.method(this.listBUnitsapi, reqdata, "post")
      .subscribe(data => {
        this.bUnits = data;
      },
        Error => {
        });
  }

bluercheckemail(){
  if(this.show_otp){
    this.fetchCaptcha()
  }
  clearInterval(this.timer);
  this.show_otherfields = false
  this.generate_otp_val = true
  this.show_otp = false
  this.emailerror=''

}
emailerror='';
active_tab1 = "active"
active_tab2 = ""
  nextprivilage() {
    this.emailerror=''
    // var email=this.PrivilagesignupdetailsForm.value.email.split("@");
    if (!this.PrivilagesignupdetailsForm.valid) {
      this.markFormGroupTouched(this.PrivilagesignupdetailsForm);
    }
    // else if (this.PrivilagesignupdetailsForm.value.password != this.PrivilagesignupdetailsForm.value.cpassword) {
    //   this.getdata.showNotification('bottom', 'right', 'Password and Confirm Password are Mis-matching,please recheck it !!', "danger");
    //   return false;
    // }
    
    // else if(((email[1].toLowerCase()).trim()!='daimler.com')){
    //   this.emailerror='Email is invalid(ex:demo@daimler.com)'
    //   this.getdata.showNotification('bottom', 'right', 'Email is invalid !!', "danger");
    //   return false;
    // }
    else {
      this.getSelectedlistDICVPrivileges()
    }
  }
  formArrayPrivilageforselected = [];
  selectedFormarrayprivilages = [];
  getSelectedlistDICVPrivileges() {
    this.formArrayPrivilageforselected = [];
    this.selectedFormarrayprivilages = [];

    let reqdata = "buids=" + this.selectedBUnits;
    // let reqdata = "buids=" + "5";

    return this.makeapi.method(this.listDICVPrivilegesapi, reqdata, "post")
      .subscribe(data => {
        this.formArrayPrivilageforselected = data;
        this.showprivilage = 'true';
        this.active_tab1 = ""
        this.active_tab2 = "active"
        $('.nav-tabs a[href="#RequestPrevilages"]').tab('show');

        for (var s = 0; s < this.formArrayPrivilageforselected.length; s++) {

          this.selectedFormarrayprivilages[s] = (this.formArrayPrivilageforselected[s].buid).toString() + (this.formArrayPrivilageforselected[s].compid).toString() + (this.formArrayPrivilageforselected[s].modid).toString();

          if (this.formArrayPrivilageforselected[s].active == 1) {
            $('#' + this.formArrayPrivilageforselected[s].buid + this.formArrayPrivilageforselected[s].compid + this.formArrayPrivilageforselected[s].modid + ':checkbox').prop('checked', true);
          }
          else {
            $("#" + this.selectedFormarrayprivilages[s]).attr('disabled', 'disabled');
            $("#container" + this.selectedFormarrayprivilages[s]).addClass("disablecheckbox")
          }
        }

        for (var g = 0; g < this.totalprivilageArray.length; g++) {
          if (this.selectedFormarrayprivilages.indexOf(this.totalprivilageArray[g]) == -1) {
            $("#" + this.totalprivilageArray[g]).attr('disabled', 'disabled');
            $("#container" + this.totalprivilageArray[g]).addClass("disablecheckbox")
          }
          else {

          }
        }
      },
        Error => {
        });
  }
  signupprocess = true;
  backtoform() {
    this.active_tab1 = "active"
      this.active_tab2 = ""
    this.showprivilage = 'false';
    $('.nav-tabs a[href="#Details"]').tab('show');
  }
  resetform() {
    this.PrivilagesignupdetailsForm.reset()
    this.signupprocess = true;
    $('.nav-tabs a[href="#Details"]').tab('show');
  }
  submitprivilage() {
    $("#submitprivilage").modal('show')
  }
  changePrivilegesSwitch(event, buid, component) {
    var prId: any;

    //  var selectPriIndex = this.selectedFormarrayprivilages.indexOf(priID);
    //     if (event.target.checked == true) {
    //       this.formArrayPrivilageforselected[selectPriIndex].active = 1;
    //     }
    //     else {
    //       this.formArrayPrivilageforselected[selectPriIndex].active = 0;
    //     }


    if (event.target.checked == true) {
      for (let i = 0; i < component.length; i++) {
        prId = (buid).toString() + (component[i].id).toString() + (component[i].modid.toString());
        if (this.selectedFormarrayprivilages.indexOf(prId) != -1) {
          var selectPriIndex= this.selectedFormarrayprivilages.indexOf(prId) 
          $('#' + prId + ':checkbox').prop('checked', true);
          this.formArrayPrivilageforselected[selectPriIndex].active = 1;
        }
      }
    }
    else {
      for (let i = 0; i < component.length; i++) {
        prId = (buid).toString() + (component[i].id).toString() + (component[i].modid.toString());
        if (this.selectedFormarrayprivilages.indexOf(prId) != -1) {
          var selectPriIndex= this.selectedFormarrayprivilages.indexOf(prId) 
          $('#' + prId + ':checkbox').prop('checked', false);
          this.formArrayPrivilageforselected[selectPriIndex].active = 1;
        }
      }
    }
  }
  Confirmsubmitprivilage() {
    var finalprivila = []
    console.log(this.formArrayPrivilageforselected)
    for (var s = 0; s < this.formArrayPrivilageforselected.length; s++) {
      delete this.formArrayPrivilageforselected[s].id;
      // delete this.formArrayPrivilageforselected[s].modid;
      // delete this.formArrayPrivilageforselected[s].active;
      if (this.formArrayPrivilageforselected[s].active == 1)
        finalprivila.push(this.formArrayPrivilageforselected[s])
    }
    var getform = this.PrivilagesignupdetailsForm.value;
    let reqdata = JSON.stringify({ "firsttimelogin":1,"name": getform.name, "email": getform.email, "shortid": getform.shortid, "phonenumber": getform.phonenumber, "bunits": this.selectedBUnits, "privilages": finalprivila, "deptid": 0, "teamid": 0, "deptname":getform.deptname, "teamname" : getform.teamname });

    return this.makeapi.method(this.dicvSignupapi, reqdata, "postjson")
      .subscribe(data => {
        if(data.status=='Success'){
          this.getdata.showNotification('bottom', 'right', " You Signedup successfully", "success");
          $("#submitprivilage").modal('hide')
          this.signupprocess = false;
          this.router.navigateByUrl('/login')
        }
       else{
        this.getdata.showNotification('bottom', 'right', data.field, "danger");
        $("#submitprivilage").modal('hide')
        }
      },
      Error =>{
        this.getdata.showNotification('bottom', 'right', 'Something went wrong, Please try again !!', "danger");
      });
  }

  search(type, value) {

  }
  formJson(name, bunitid, cunitid, moduleid, event) {
    var priID = bunitid.toString() + cunitid.toString() + moduleid.toString();
    var selectPriIndex = this.selectedFormarrayprivilages.indexOf(priID);
    if (event.target.checked == true) {
      this.formArrayPrivilageforselected[selectPriIndex].active = 1;
    }
    else {
      this.formArrayPrivilageforselected[selectPriIndex].active = 0;
    }
  }

  usertype = 'internal'
  selectuser(type) {
    // this.getalluser();
    if (type == 'internal') {
      this.usertype = 'internal'
      $('#internalfilter').removeClass("activenavleft")
      $('#externalfilter').removeClass("activenavleft")
      $('#internalfilter').addClass("activenavleft")

    }
    else {
      this.usertype = 'external';
      $('#externalfilter').removeClass("activenavleft")
      $('#internalfilter').removeClass("activenavleft")
      $('#externalfilter').addClass("activenavleft")

    }
  }
  login_page(){
    clearInterval(this.timer);
    this.router.navigateByUrl('/login')
  }
  show_otherfields = false
  captchaImg
  captchaId
  fetchCaptcha() {
    this.generate_otp_val = true
    this.overall_hide = true
    this.show_otp = false
    this.show_otherfields = false
    //call captacha image and assign to captchaImg
    var getCaptchaUrl = this.getdata.appconstant + 'getCaptcha';
    this.makeapi.method(getCaptchaUrl, "", "get")
    .subscribe(response => {
      clearInterval(this.timer);
      this.captchaImg = 'data:image/jpeg;base64,'+response.image;
      this.captchaId = response.id; 
      
    });

  }
  verify_captcha(){
    let value = $("#captcha_text").val()
    let reqdata = "id="+this.captchaId+"&value="+value;  
  var getemail=this.PrivilagesignupdetailsForm.value.email
  var email = [""]
  if(getemail != "" && getemail != null){
    email = getemail.split("@");
  }
  if(email.length > 1){ 
  if((((email[1].toLowerCase()).trim()!='daimler.com') && ((email[1].toLowerCase()).trim()!='daimlertruck.com')) || (!this.PrivilagesignupdetailsForm.controls.email.valid)){
    this.emailerror='Email is invalid(ex:demo@daimler.com (or) demo@daimlertruck.com)'
    this.getdata.showNotification('bottom', 'right', 'Email is invalid !!', "danger");
  }else if(value == ""){
    this.getdata.showNotification('bottom', 'right', 'Please Enter the Captcha !!', "danger");
  }
  else{
    var verifyCaptchaUrl = this.getdata.appconstant + 'verifyCaptcha';
       this.makeapi.method(verifyCaptchaUrl, reqdata, "post")
    .subscribe(data => {
      if(data.status.toLowerCase() == 'success'){
        this.generate_otp()
      }else{
        this.getdata.showNotification('bottom', 'right', 'Invalid Captcha', "danger");
      }
      
    });
    }
}else{
  this.emailerror='Email is invalid(ex:demo@daimler.com (or) demo@daimlertruck.com)'
  this.getdata.showNotification('bottom', 'right', 'Email (or) Captcha is invalid !!', "danger");
}
  }
  generate_otp_val = true
  show_otp = false
  generate_otp(){
    let generateMailOtp = this.getdata.appconstant + 'generateMailOtp'
    let reqdata = "email="+this.PrivilagesignupdetailsForm.value.email + "&type=1"
    this.makeapi.method(generateMailOtp, reqdata, "post")
    .subscribe(data => {
        if(data.status.toLowerCase() == 'success'){
          this.generate_otp_val = false
          this.show_otp = true
          this.remainingTime = data.valid_duration_in_secs
          this.start()
          this.getdata.showNotification('bottom', 'right', data.field, "success");
          setTimeout(()=>{
            $( "#otp_text" ).focus();
          },10)
        }else{
          this.getdata.showNotification('bottom', 'right', data.field, "danger");

        }
    });
  }

   timer: any; // Timer variable
   private remainingTime:number; // Remaining time in seconds
   interval: number = 1000; // Interval in milliseconds (1 second)
   otp_timer = ''

  start() {
    this.timer = setInterval(() => {
      this.remainingTime--;
      if (this.remainingTime <= 0) {
        this.stop();
      } else {
        this.otp_timer = this.formatTime(this.remainingTime);
      }
    }, this.interval);
  }

  stop() {
    clearInterval(this.timer);
    this.remainingTime = 0
    this.getdata.showNotification('bottom', 'right', "Timeout", "danger");
    this.generate_otp_val = true
    this.show_otp = false
    this.otp_timer = ''
    this.show_otherfields = false
    this.fetchCaptcha()
    this.deleteCookie('disc-cookies');
  }

  private formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  }


  overall_hide = true
  token
  setCookie(cname, cvalue, expireHrs) {
    var d = new Date();
    d.setTime(d.getTime() + (expireHrs * 3600000000));
    var expires = "expires=" + d.toUTCString();
    window.document.cookie = cname + "=" + cvalue + "; " + expires;
  }
  getToken() {
    this.token = this.getCookie('disc-cookies');
  }
  getCookie(cname) {
    var name = cname + "=";
    var cArr = window.document.cookie.split(';');
    for (var i = 0; i < cArr.length; i++) {
      var c = cArr[i].trim();
      if (c.indexOf(name) == 0)
        return c.substring(name.length, c.length);
    }
    return "";
  }
  deleteCookie(cname) {
    var d = new Date();
    d.setTime(d.getTime() - (3 * 3600000000));
    var expires = "expires=" + d.toUTCString();
    window.document.cookie = cname + "=" + "; " + expires;

}
  verify_otp(){
    var verifyMailOtp = this.getdata.appconstant + 'verifyMailOtp';
    let value = $("#otp_text").val()
    let reqdata = "email="+this.PrivilagesignupdetailsForm.value.email+"&otp="+value;
      if(value != "" && this.PrivilagesignupdetailsForm.controls.email.valid){
       this.makeapi.methodNoAuth(verifyMailOtp, reqdata, "postsignup")
    .subscribe(response => {
      var data = response;
      if(response.headers.get('access-control-bharatbenz-token') != null){
      this.setCookie('disc-cookies', response.headers.get('access-control-bharatbenz-token'), 2)
      this.makeapi.getToken();
        this.overall_hide = false
      this.show_otherfields = true
      this.show_otp = false
      this.otp_timer = ''
      this.otp_timer = ''
      this.remainingTime = 0
        clearInterval(this.timer);
        setTimeout(()=>{
          $("#otpcopymail").val(this.PrivilagesignupdetailsForm.value.email)
        },10)
      
      this.getdata.showNotification('bottom', 'right', 'OTP Verified Successfully', "success");
      
      this.getallBUnits();
      this.getallcomponents();
      this.remainingTime = 300;
      this.start()
      // this.getalldepartment();
      // this.getallteam();
      this.getalldesignation();
      }else{
this.getdata.showNotification('bottom', 'right', 'Something went wrong, Please try again !!', "danger");
      }
    },
    Error =>{
      this.getdata.showNotification('bottom', 'right', 'Something went wrong, Please try again !!', "danger");
    });
      }else{
        this.getdata.showNotification('bottom', 'right', 'Please Enter the OTP !!', "danger");
      }
  }
  isValid = true
  password_validation(val){
   if((this.PrivilagesignupdetailsForm['controls']['password'].value.length >= 12 && this.PrivilagesignupdetailsForm['controls']['cpassword'].value.length >= 12)
   && (this.PrivilagesignupdetailsForm['controls']['password'].valid && this.PrivilagesignupdetailsForm['controls']['cpassword'].valid) 
   && (this.PrivilagesignupdetailsForm['controls']['password'].value !== this.PrivilagesignupdetailsForm['controls']['cpassword'].value)){
      this.isValid = false
   }else{
    this.isValid = true
   }
  }
  resend_otp(){
    clearInterval(this.timer);
    this.fetchCaptcha()
    this.generate_otp_val = true
    this.show_otp = false
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

}
